import { createFileRoute } from "@tanstack/react-router"

import { AdminDesignPage } from "@/pages/admin/design"

export const Route = createFileRoute("/_authenticated/admin/design")({
  component: AdminDesignPage,
})
